import { DataModelContext } from '../configure/ConfigureProvider';
import { useContext } from 'react';

export const useDataModels = () => {
  const dataModelAPIMapper = useContext(DataModelContext);
  return dataModelAPIMapper;
};
